'use client';

import {
	calculateAverageEntryPrice,
	ENUM_UTILS,
} from '@velocity-exchange/common';
import { MarketType } from '@velocity-exchange/sdk';
import useMarketsInfoStore from 'src/stores/useMarketsInfoStore';
import type { ParentOrderInfo } from 'src/@types/historyTables';

interface AvgFillPriceCellProps {
	order: ParentOrderInfo;
}

export function AvgFillPriceCell({ order }: AvgFillPriceCellProps) {
	const {
		baseAssetAmountFilled,
		quoteAssetAmountFilled,
		marketIndex,
		marketType,
	} = order;
	const getMarketInfoByIndexAndType = useMarketsInfoStore(
		(s) => s.getMarketInfoByIndexAndType
	);

	if (baseAssetAmountFilled.eqZero()) {
		return <span className="text-text-tertiary">-</span>;
	}

	const avgPriceBn = calculateAverageEntryPrice(
		quoteAssetAmountFilled,
		baseAssetAmountFilled
	);

	const priceDecimalOverride = ENUM_UTILS.match(marketType, MarketType.PERP)
		? getMarketInfoByIndexAndType(marketIndex, MarketType.PERP)?.genericInfo
				.priceDisplayDecimals
		: undefined;

	return avgPriceBn.toNotional(undefined, undefined, priceDecimalOverride);
}
